import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  showPrice?: boolean;
  href?: string;
}
export function Button({
  children,
  className = '',
  showPrice = false,
  href
}: ButtonProps) {
  const baseClasses = `bg-bronze hover:bg-bronze-dark text-white font-medium py-4 px-8 rounded-none transition-colors duration-300 shadow-sm flex flex-col items-center justify-center gap-1 w-full sm:w-auto cursor-pointer no-underline ${className}`;
  const content = <>
      <span className="text-lg tracking-wide" data-id="element-61">{children}</span>
      {showPrice && <span className="text-sm text-white/80 font-normal tracking-wider" data-id="element-62">
          $14.00 USD
        </span>}
    </>;
  // External link — use <a> tag (won't be blocked by popup blockers)
  if (href && href.startsWith('http')) {
    return <motion.a whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} href={href} target="_blank" rel="noopener noreferrer" className={baseClasses} onClick={() => {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'AddToCart', {
          content_name: 'Rutina de Autocuidado para Pies Sensibles',
          content_type: 'product',
          value: 14.0,
          currency: 'USD'
        });
      }
    }} data-id="element-63">
        {content}
      </motion.a>;
  }
  // Internal scroll link — use <button>
  const handleClick = () => {
    if (href) {
      const el = document.querySelector(href);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 20;
        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={baseClasses} data-id="element-64">
      {content}
    </motion.button>;
}